import { useState, useEffect } from 'react';

const useMediaQuery = (query) => {
	const [matches, setMatches] = useState(false);

	useEffect(() => {
		const mediaQuery = window.matchMedia(query);

		const handleWindowResize = (event) => {
			setMatches(event.matches);
		};

		handleWindowResize(mediaQuery);

		// Listen for changes
		mediaQuery.addEventListener('change', handleWindowResize);

		return () => {
			mediaQuery.removeEventListener('change', handleWindowResize);
		};
	}, [query]);

	return matches;
};

export default useMediaQuery;
